<script>
import DynamicTable from '../../components/DynamicTable.vue'
import DynamicForm from '../../components/DynamicForm.vue'
import Sidebar from '../../components/Sidebar.vue'
import Topbar from '../../components/Topbar.vue'
import toast from '@/methods/toast'
import messages from '@/methods/messages'
import services from '@/http'
import schemaUsers from './schema'
import modelUsers from './model'
import { mapState } from 'vuex'

export default {
  name: 'Dfes',
  components: {
    DynamicTable,
    Sidebar,
    Topbar,
    DynamicForm
  },
  data () {
    return {
      paginacao: {
        sizeForPages: 30,
        currentPage: 1,
      },
      showForm: false,
      myFields: ['Id', 'Nome', 'Login', 'Tipo', 'status'],
      myFieldsNames: ['id', 'nome', 'login', 'tipo', 'status'],
      myData: [],
      filter: {
        status: 'A',
        tipo: 'C'
      },
      tipoOptions: [
        {
          id: 0,
          value: 'C',
          description: 'Contador'
        },
        {
          id: 1,
          value: 'R',
          description: 'Representante'
        },
        {
          id: 2,
          value: 'D',
          description: 'Domtec'
        },
        {
          id: 3,
          value: 'A',
          description: 'Administrador'
        },
      ],
      statusOptions: [
        {
          id: 0,
          value: 'I',
          description: 'Inativo'
        },
        {
          id: 1,
          value: 'A',
          description: 'Ativo'
        }
      ],
      schema: schemaUsers,
      currentUser: modelUsers,
      representantes: [],
      contadores: [],
      filtroNome: ''
    }
  },
  created () {
    if (this.user.user.tipo === 'D' || this.user.user.tipo === 'A') {
      this.loadTable()
      this.loadRepresentantes()
      this.loadContadores()
      this.loadCalback()
    } else {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    clearCmb (filter) {
      this.filter[filter] = null
    },
    filterData(inc) {
      if (inc !== 0)
        this.paginacao.currentPage = this.paginacao.currentPage + inc;
      else
        this.paginacao.currentPage = 1

      this.loadTable()
      window.scrollTo(0, 10)
    },
    loadTable () {
      let action = {
        form: { 
          nome: this.filtroNome,
          status: this.filter.status,
          tipo: this.filter.tipo,
          paginacao: this.paginacao
        }
      }
      services.auth.getUsers(action)
        .then(res => {
          let usersWs = res.body.users.users
          let newUsers = []
          for (let i = 0; i < usersWs.length; i++) {
            let userFor = {
              id: usersWs[i].id,
              nome: usersWs[i].nome,
              login: usersWs[i].login,
              tipo: usersWs[i].tipo,
              status: usersWs[i].status,
              senha: usersWs[i].senha,
              email: usersWs[i].email,
              representante: usersWs[i].representante,
              contador: usersWs[i].contador
            }
            newUsers.push(userFor)
          }
          this.myData = newUsers
        })
        .catch(err => {
          let msg = messages.getMessage(err, 'Falha ao selecionar usuários!')
          toast.toastError(msg)
        })
    },
    loadCalback () {      
        schemaUsers.callBackSuccess = function (param) {
          return new Promise((resolve, reject) => {
            if (param.id === 0 || param.id === undefined || param.id === null) {
              services.auth.postUsers({ user: param }).then(() => {
                toast.toastSuccess('Usuario inserido com sucesso!')                         
                resolve()
              }).catch(res => {
                let msg = messages.getMessage(res, 'Falha ao inserir usuário!')
                toast.toastError(msg)
                reject()
              })
            } else {
              services.auth.putUsers({ user: param }).then(() => {
                toast.toastSuccess('Usuario alterado com sucesso!')              
                resolve()
              }).catch(res => {
                let msg = messages.getMessage(res, 'Falha ao alterar usuário!')
                toast.toastError(msg)
                reject()
              })
            }
          })
        }
    },
    loadRepresentantes () {
      services.auth.representantes({}).then(res => {
        this.representantes = res.body.representantes.representantes
      })
    },
    loadContadores () {
      services.auth.contadores({}).then(res => {
        this.contadores = res.body.contadores.contadores
      })
    },    
    setCurrentUser (paramUser) {
      this.currentUser = paramUser
      this.showModal(true)
    },
    showModal (state) {     
      for (let iRep = 0; iRep < schemaUsers.fields.length; iRep++) {
        if (schemaUsers.fields[iRep].model === 'representante') {
          schemaUsers.fields[iRep].itens = this.representantes
        }

        if (schemaUsers.fields[iRep].model === 'contador') {
          schemaUsers.fields[iRep].itens = this.contadores
        }     
      }

      this.showForm = state
    },
    addUser () {
      this.currentUser = modelUsers
      this.showModal(true)
    }
  }
}
</script>

<template>
  <div class="home">
    <Topbar />
    <DynamicForm
      v-bind:schema="schema"
      v-bind:showForm="showForm"
      v-bind:model="currentUser"
      v-on:updateStateShowForm="showModal"
    />
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper">
        <div class="container-fluid">
          <div class="card mb-3 border-flat">
            <div class="card-body">
                <form class="form-filter">
                  <div class="row">
                    <div class="col-md m-left">
                      <label for="filter-usuario">Usuário</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Usuário"
                        name="filter-usuario"
                        v-model="filtroNome"
                      >
                    </div>

                    <div class="col-md-2 ml-0 p-0">
                      <label for="filter-data-fim">Status</label>
                      <select
                        class="form-control"
                        v-model="filter.status"
                        v-on:keyup.8="clearCmb('status')"
                        v-on:keyup.46="clearCmb('status')"
                      >
                        <option
                          v-for="subitem in statusOptions"
                          :key="subitem.id"
                          :value="subitem.value"
                        >
                          {{subitem.description}}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-2 ml-3 p-0 mr-3">
                      <label for="filter-data-fim">Tipo</label>
                      <select
                        class="form-control"
                        v-model="filter.tipo"
                        v-on:keyup.8="clearCmb('tipo')"
                        v-on:keyup.46="clearCmb('tipo')"
                      >
                        <option
                          v-for="subitem in tipoOptions"
                          :key="subitem.id"
                          :value="subitem.value"
                        >
                          {{subitem.description}}
                        </option>
                      </select>
                    </div>

                  </div>
                  <div class="mt-2 text-right">
                      <button
                        type="button"
                        class="btn bg-blue-dt btn-psq"
                        v-on:click="filterData(0)">
                        Pesquisar
                      </button>
                      <button
                        type="button"
                        class="btn bg-blue-dt btn-psq"
                        v-on:click="addUser">
                        Add
                      </button>
                    </div>
                </form>
            </div>
          </div>
          <DynamicTable
            v-bind:myFields="myFields"
            v-bind:fieldsNames="myFieldsNames"
            v-bind:generalData="myData"
            v-on:setCurrentModel="setCurrentUser"
          />
        </div>
      </div>
    </div>

    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>

    <div class="container">
      <div class="row">
        <div class = "ml-auto">
          <nav aria-label="Navegação de página exemplo" v-if="paginacao.currentPage !== 0">
            <ul class="pagination justify-content-right">
              <li class="page-item" v-if="paginacao.currentPage > 1">
                <a class="page-link pointer-cursor" v-on:click="filterData(-1)">Anterior</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link pointer-cursor" tabindex="-1">{{ parseInt(paginacao.currentPage) }}</a>
              </li>
              <li class="page-item" v-if="myData.length >= paginacao.sizeForPages">
                <a class="page-link pointer-cursor" v-on:click="filterData(+1)">Próximo</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
  .btn-psq{ margin-left: 5px }
  .form-filter{margin-left: 10px;}
</style>
